<template>
<Row>
    <i-col span="24">
        <Row :gutter="10">
        <i-col :span="spanNum" v-show="showCountry">
            <dropdown :placeholder="placeholder[0]" ref="country"  @onChange="change" :me="self" :cascade="countryCascade" v-model="formCustom.country" :disabled="disabled" :dataCfg="countryDataCfg" :label="'shortName'" :code="'id'"></dropdown>
        </i-col>
        <i-col :span="spanNum" v-if="showProvince">
            <dropdown :placeholder="placeholder[1]" ref="province" clearable @onClear="provinceClear" @onChange="change" :me="self" :cascade="provinceCascade" v-model="formCustom.province" :disabled="disabled" :dataCfg="provinceDataCfg" :label="'shortName'" :code="'id'"></dropdown>
        </i-col>
        <i-col :span="spanNum" v-if="showCity">
            <dropdown :placeholder="placeholder[2]" ref="city" clearable @onClear="cityClear" @onChange="change" :me="self" :cascade="cityCascade" v-model="formCustom.city" :disabled="disabled" :dataCfg="cityDataCfg" :label="'shortName'" :code="'id'"></dropdown>
        </i-col>
        <i-col :span="spanNum" v-if="showZone">
            <dropdown :placeholder="placeholder[3]" ref="zone" clearable @onClear="zoneClear" @onChange="change" :me="self" :cascade="zoneCascade" v-model="formCustom.zone" :disabled="disabled" :dataCfg="zoneDataCfg" :label="'name'" :code="'id'"></dropdown>
        </i-col>
        </Row>
    </i-col>
</Row>
</template>
<script>
/**
 * 使用方式
 * 1、模板如下：如果配置了xxxAttrStr则可以分开给设置的属性赋值
<region v-model="formCustom.consigneeDetail" 
                    ref="consigneeDetail"
                    :countryAttrStr="'formCustom.addressCountryCode'"
                    :provinceAttrStr="'formCustom.addressProvinceCode'"
                    :cityAttrStr="'formCustom.addressCityCode'"
                    :zoneAttrStr="'formCustom.addressZoneCode'"
                    :me="self"
                    ></region>
    2、如果需要反向勾选
    mounted:function(){
        this.self=this
        //在表单有数据后，视情况调用
        this.$nextTick(function(){
            this.$refs.consigneeDetail.initData()
        })
    }
 */
    export default {
        name:"region",
        //其中 width 规定线条的长度，还可以是百分比；color 表示颜色，size 表示厚度；
        props: {
            placeholder:{
                type: Array,
                default:()=>{
                   return ["请选择","请选择","请选择","请选择"]
                }
            },
            me:{
                type: Object
            },
            value: {
                type: [String, Array],
                default: ''
            },
            showCountry:{
                type: Boolean,
                default: true
            },
            showProvince:{
                type: Boolean,
                default: true
            },
            showCity:{
                type: Boolean,
                default: true
            },
            showZone:{
                type:Boolean,
                default:true
            },
            //是否设置name，规则为以code字段设置，替换code为name
            setName:{
                type:Boolean,
                default:true
            },
            labelWidth: {
                type: String,
                default:"120"
            },
            disabled:{
                type: Boolean,
                default: false
            },
            onChange:{
                type: Function
            },
            countryAttrStr: {
                type: String,
                default:""
            },
            provinceAttrStr: {
                type: String,
                default:""
            },
            cityAttrStr: {
                type: String,
                default:""
            },
            zoneAttrStr: {
                type: String,
                default:""
            }
        },
        
        data () {
            return {
                self:{},
                spanNum:6,
                countryDataCfg:{
                    sc:"merchant",
                    url:'regionManage/selectToList',
                    params: {"parentId":""}
                },
                countryCascade:{
                    to:"province"
                },
                provinceDataCfg:{
                    sc:"merchant",
                    url:'regionManage/selectToList',
                    params: {"parentId":""}
                },
                provinceCascade:{
                    from:"country",
                    to:"city",
                    paramsStr:"parentId"
                },
                cityDataCfg:{
                    sc:"merchant",
                    url:'regionManage/selectToList',
                    params: {"parentId":""}
                },
                cityCascade:{
                    from:"province",
                    to:"zone",
                    paramsStr:"parentId"
                },
                zoneDataCfg:{
                    sc:"merchant",
                    url:'regionManage/selectToList',
                    params: {"parentId":""}
                },
                zoneCascade:{
                    from:"city",
                    paramsStr:"parentId"
                },
                selectData:"",
                formCustom:{
                    country:"",
                    province:"",
                    city:"",
                    zone:""
                }
            }
        },
        mounted(){
            let self=this
            this.self=this
            //默认选择国家为中国
            if(this.$utils.isEmptyObject(this.me) || !this.getAttrValue(this.countryAttrStr)){
                this.formCustom.country="10000044"
                this.$emit('input', "10000044")
            }
            this.$nextTick(function(){
                self.init()
            })
        },
        watch: { 
            value(newValue,oldValue){
                //清空选择的值后，同步formCustom与页面的formCustom的地区默认值
                if (newValue === ''){
                    this.selectData = ""
                    this.init()
                    // this.formCustom=this.$options.data().formCustom
                    // this.$nextTick(function(){
                    //     this.country = "10000044"
                    // })
                }else if(newValue!=oldValue){
                    this.selectData = newValue
                }
            },
            "formCustom.country":function(newValue,oldValue){
                if(newValue!=oldValue&&this.countryAttrStr!=""){
                    this.setAttrValue(this.countryAttrStr,newValue,"country")
                }
            },
            "formCustom.province":function(newValue,oldValue){
                if(newValue!=oldValue&&this.provinceAttrStr!=""){
                    this.setAttrValue(this.provinceAttrStr,newValue,"province")
                }
            },
            "formCustom.city":function(newValue,oldValue){
                if(newValue!=oldValue&&this.cityAttrStr!=""){
                    this.setAttrValue(this.cityAttrStr,newValue,"city")
                }
            },
            "formCustom.zone":function(newValue,oldValue){
                if(newValue!=oldValue&&this.zoneAttrStr!=""){
                    this.setAttrValue(this.zoneAttrStr,newValue,"zone")
                }
            }
        },
        created(){
            let showNum=0;
            if(this.showCountry){
                showNum++
            }
            if(this.showProvince){
                showNum++
            }
            if(this.showCity){
                showNum++
            }
            if(this.showZone){
                showNum++
            }
            this.spanNum=24/showNum
        },
        methods:{
            init(){
                //如果me为空对象，使用组件默认值
                if(!this.$utils.isEmptyObject(this.me)){
                    this.formCustom.country=this.getAttrValue(this.countryAttrStr)
                    this.formCustom.province=this.getAttrValue(this.provinceAttrStr)
                    this.formCustom.city=this.getAttrValue(this.cityAttrStr)
                    this.formCustom.zone=this.getAttrValue(this.zoneAttrStr)
                }
                this.provinceDataCfg.params={"parentId":this.formCustom.country}
                this.cityDataCfg.params={"parentId":this.formCustom.province}
                this.zoneDataCfg.params={"parentId":this.formCustom.city}
            },
            initData(){
                if(this.countryAttrStr!=""){
                    // this.formCustom.country=this.getAttrValue(this.countryAttrStr)
                }
                if(this.provinceAttrStr!=""){
                    this.formCustom.province=this.getAttrValue(this.provinceAttrStr)
                }
                if(this.cityAttrStr!=""){
                    this.formCustom.city=this.getAttrValue(this.cityAttrStr)
                }
                if(this.zoneAttrStr!=""){
                    this.formCustom.zone=this.getAttrValue(this.zoneAttrStr)
                }
            },
            change(value){
                //先不让清空
                if(value&&value!=""){
                    this.$emit('input', value)
                    this.$emit('onChange',value)
                }
            },
            provinceClear(){
                let value=this.formCustom.country
                this.$emit('input', value)
                this.$emit('onChange',value)
            },
            cityClear(){
                let value=this.formCustom.province
                this.$emit('input', value)
                this.$emit('onChange',value)
            },
            zoneClear(){
                let value=this.formCustom.city
                this.$emit('input', value)
                this.$emit('onChange',value)
            },
            //根据属性名称获取属性值，例如：attrStr="formCustom.addressCountryCode"
            getAttrValue(attrStr){
                let arr=attrStr.split(".")
                let attrCache=this.me
                for(let i=0;i<arr.length;i++){
                    attrCache=attrCache?attrCache[arr[i]]:""
                }
                return attrCache
            },
            setAttrValue(attrStr,value,refName){
                let self=this
                self.setAttrValueAndName(attrStr,value)
                if(refName&&self.setName){
                    //设置name
                    let valueObj=self.$refs[refName].getDataByCode(value),
                    itemName=valueObj.shortName||valueObj.name,
                    itemAttr=attrStr.replace("Code","Name");
                    if(!self.$utils.isEmptyObject(valueObj)){
                        self.setAttrValueAndName(itemAttr,itemName)
                    }else{
                        //由于初始化给了值，所以需要调用异步获取的方法来根据code获取值
                        self.$refs[refName].getDataAsyncByCode(value).then(function(valueObj){
                            itemName=valueObj.shortName||valueObj.name;
                            self.setAttrValueAndName(itemAttr,itemName)
                        })
                    }
                }
            },
            setAttrValueAndName(attrStr,value){
                let arr=attrStr.split(".")
                let attrCache=this.me
                for(let i=0;i<arr.length;i++){
                    if(i==arr.length-1){
                        attrCache[arr[i]]=value
                        this.setValidate(arr[0],arr[i])
                    }else{
                        attrCache=attrCache[arr[i]]
                    }
                }
            },
            //值改变后，比如清空时，把页面的数据与当前组件数据同步
            getAttrValue(attrStr){
                let arr=attrStr.split(".")
                let attrCache=this.me
                for(let i=0;i<arr.length;i++){
                    if(i==arr.length-1){
                        return attrCache[arr[i]]
                    }else{
                        attrCache=attrCache[arr[i]]
                    }
                }
            },
            //手动触发检验器
            setValidate(formCustomName,fieldName){
                let formCustom=this.me.$refs[formCustomName]
                if(formCustom){
                    let rules=formCustom.rules
                    if(rules&&rules[fieldName])formCustom.validateField(fieldName)
                }
            },
            //获取所有选择的code值
            getAllData(){
                return this.formCustom
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/common/region.vue